export class NbChatOptions {
  messageGoogleMapKey?: string;
}
